import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

import { type ISliderBlockTypeOneModel } from '../../external/models/SliderBlockTypeOneModel';

/**
 * @description Событие: выбран другой чип (таб) в слайдере типа SliderBlockTypeOne.
 */
export function trackSliderBlockTypeOneChipSelect(
  title: string,
  id: string,
  sliderBlockTypeOneModel: ISliderBlockTypeOneModel,
): void {
  ca('eventSite', {
    action: `${id}_click_landing_slider_chips`,
    category: 'Promo',
    label: `${id}_slider_chip_click`,
    name: 'oldevent',
    page: {
      extra: {
        tab_name: sliderBlockTypeOneModel.chipsOption.label,
        title,
      },
    },
    products: [createDeveloperProduct()],
  });
}
